export default "__VITE_ASSET__BfhYsgLu__"